<template>
  <div class="authorInfo">
    <div class="InfoWrap" v-show="applyStatus == 3">
      <h3>
        签约
        <a href="javaScript:" v-if="isSign" class="applyStatus fr"
          >审核状态：
          {{
            signStatus == 0
              ? "待责编审核"
              : signStatus == 1
              ? "待主编审核"
              : signStatus == 2
              ? "待邮寄"
              : signStatus == -2
              ? "签约被驳回"
              : "签约完成"
          }}</a
        >
      </h3>
      <div class="signInfo">
        <template v-if="!isSign">
          <el-form
            ref="applyForm"
            :model="signDate"
            :rules="rules"
            label-width="100px"
            label-position="left"
            style="margin-top:24px"
          >
            <p class="hint">
              特别提醒：请认真填写一下信息，以免以后修改给您带来不便！
            </p>
            <p>手持身份证照片</p>
            <div class="imgbox clearfix">
              <el-upload
                class="front-uploader fl uploader"
                :action="uploadurl"
                :headers="headers"
                :data="uploaddata1"
                :on-success="handleAvatarSuccess"
              >
                <img
                  v-if="signDate.idFrontImg"
                  :src="this.imgURL + '/' + signDate.idFrontImg"
                  class="front"
                  width="150px"
                  height="150px"
                />
                <img
                  src="~img/author/zheng.png"
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                />
              </el-upload>
              <div class="egfront fl clearfix">
                <p class="fl">实例：</p>
                <img class="fl" src="~img/author/leg1.png" alt="" />
                <ol class="fl">
                  <li>1.需要身份证本人手持证件</li>
                  <li>2.照片需五官清晰可见</li>
                  <li>3.身份证上的信息需无滤</li>
                  <li>4.拍照需露出手臂</li>
                </ol>
              </div>
            </div>
            <div class="imgbox clearfix">
              <el-upload
                class="uploader fl reverse-uploader"
                :action="uploadurl"
                :headers="headers"
                :data="uploaddata2"
                :on-success="handlereverseSuccess"
              >
                <img
                  v-if="signDate.idBackImg"
                  :src="this.imgURL + '/' + signDate.idBackImg"
                  class="reserve"
                  width="150px"
                  height="150px"
                />
                <img
                  src="~img/author/fan.png"
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                />
              </el-upload>
              <div class="egfront fl clearfix">
                <p class="fl">实例：</p>
                <img class="fl" src="~img/author/leg2.png" alt="" />
                <ol class="fl">
                  <li>1.需要身份证本人手持证件</li>
                  <li>2.照片需五官清晰可见</li>
                  <li>3.身份证上的信息需无滤</li>
                  <li>4.拍照需露出手臂</li>
                </ol>
              </div>
            </div>
            <el-form-item label="作家笔名">
              <el-input
                v-model="signDate.name"
                readonly
                placeholder="作家笔名"
                class="login-form-input readonly"
                ref="bname"
              ></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
              <el-input
                v-model="signDate.realName"
                readonly
                placeholder="真实姓名"
                class="login-form-input readonly"
                ref="name"
              ></el-input>
            </el-form-item>
            <el-form-item label="QQ">
              <el-input
                v-model="signDate.im"
                placeholder="QQ"
                readonly
                class="login-form-input readonly"
                ref="QQ"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input
                readonly
                v-model="signDate.idNo"
                placeholder="请输入真实的身份证号"
                class="login-form-input readonly"
                ref="IDnumber"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系地址">
              <el-input
                v-model="signDate.address"
                readonly
                placeholder="联系地址"
                class="login-form-input readonly"
                ref="address"
              ></el-input>
            </el-form-item>
            <el-form-item prop="zipcode" label="邮编">
              <el-input
                v-model="signDate.zipcode"
                placeholder="邮编"
                class="login-form-input"
                ref="address"
              ></el-input>
            </el-form-item>
            <el-form-item prop="email" label="有效邮箱">
              <el-input
                v-model="signDate.email"
                placeholder="为了避免您的损失，请您务必填写邮箱！"
                class="login-form-input"
                ref="email"
              ></el-input>
            </el-form-item>
            <el-form-item class="code" prop="code" label="获取验证码">
              <div class="getcodebox">
                <el-input
                  placeholder="获取验证码"
                  v-model="signDate.code"
                  class="getcode"
                >
                </el-input>
                <div class="getmycode" v-show="isclick" @click="getCode">
                  获取
                </div>
                <div
                  class="getmycode isnoneclick"
                  v-show="!isclick"
                  width="117px"
                >
                  重新发送 ({{ timecount }}s)
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="bank" label="开户行全称">
              <el-input
                v-model="signDate.bank"
                placeholder="为了避免您的损失，请您务必填写开户行全称！填写样式：招商银行 xx省xx市xx区xx支行"
                class="login-form-input"
                ref="bank"
              ></el-input>
            </el-form-item>
            <p class="hintblue">
              温馨提示：为了您能收到付款，请详细填写银行相关信息。开户行仅限于中国大陆银行，具体到
              支行，否则无法汇款不予结算（无法确认开户支行，请咨询您的开户行进行查询）
            </p>
            <el-form-item prop="account" label="银行账号">
              <el-input
                v-model="signDate.account"
                placeholder="为了避免您的损失，请您务必填写银行账号！"
                class="login-form-input"
                ref="account"
              ></el-input>
            </el-form-item>
            <el-form-item prop="bankcode" label="授权协议">
              <el-input
                v-model="signDate.bankname"
                type="textarea"
                readonly
                class="login-form-input"
                ref="bankname"
              ></el-input>
              <p
                class="hint"
                style="margin-bottom:0px;line-height:16px;margin-top:10px;text-align:left"
              >
                特别提示：请仔细核对账号信息，如有误，不予结算！
              </p>
            </el-form-item>
            <el-form-item>
              <el-button
                class="usersub"
                size="medium"
                @click="submitapply('applyForm')"
                >申请</el-button
              >
            </el-form-item>
          </el-form>
        </template>
        <template v-if="isSign">
          <el-form
            ref="applyForm"
            :model="signDate"
            :rules="rules"
            label-width="100px"
            label-position="left"
            style="margin-top:24px"
          >
            <el-form-item prop="bname" label="证件照片">
              <div class="IDphoto">
                <img
                  :src="this.imgURL + '/' + this.signDate.idFrontImg"
                  alt=""
                />
                <img
                  :src="this.imgURL + '/' + this.signDate.idBackImg"
                  alt=""
                />
              </div>
            </el-form-item>
            <el-form-item label="作家笔名">
              <el-input
                v-model="signDate.name"
                readonly
                placeholder="作家笔名"
                class="login-form-input"
                ref="bname"
              ></el-input>
            </el-form-item>
            <el-form-item label="真实笔名">
              <el-input
                v-model="signDate.realName"
                readonly
                placeholder="真实笔名"
                class="login-form-input"
                ref="name"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input
                v-model="signDate.idNo"
                placeholder="请输入真实的身份证号"
                readonly
                class="login-form-input"
                ref="IDnumber"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系地址">
              <el-input
                v-model="signDate.address"
                placeholder="联系地址"
                readonly
                class="login-form-input"
                ref="address"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮编">
              <el-input
                v-model="signDate.zipcode"
                placeholder="邮编"
                readonly
                class="login-form-input"
                ref="address"
              ></el-input>
            </el-form-item>
            <el-form-item label="有效邮箱*">
              <el-input
                v-model="signDate.email"
                placeholder="为了避免您的损失，请您务必填写邮箱！"
                readonly
                class="login-form-input"
                ref="email"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户行全称*">
              <el-input
                readonly
                v-model="signDate.bank"
                placeholder="为了避免您的损失，请您务必填写开户行全称！"
                class="login-form-input"
                ref="bankname"
              ></el-input>
            </el-form-item>
            <el-form-item label="银行账号*">
              <el-input
                v-model="signDate.account"
                readonly
                placeholder="为了避免您的损失，请您务必填写银行账号！"
                class="login-form-input"
                ref="account"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="signStutus">
            <span class="active">作家提交审核</span> >
            <span :class="{ active: signStatus >= 0 }">待责编审核</span> >
            <span :class="{ active: signStatus >= 1 }">待主编审核</span> >
            <span :class="{ active: signStatus >= 2 }">待邮寄</span> >
            <span :class="{ active: signStatus >= 3 }">签约完成</span>
          </div>
          <table v-if="signStatus == 3">
            <tr>
              <th>审核人</th>
              <th>操作</th>
              <th>备注</th>
              <th></th>
            </tr>
            <tr>
              <td></td>
              <td style="color:rgba(9,178,26,1);">通过</td>
              <td style="color:rgba(92,92,92,1);">内部测试</td>
              <td style="color:rgba(136,136,136,1);">2019-07-03 14:43:12</td>
            </tr>
            <tr>
              <td></td>
              <td>通过</td>
              <td>内部测试</td>
              <td>2019-07-03 14:43:12</td>
            </tr>
            <tr>
              <td></td>
              <td>通过</td>
              <td>内部测试</td>
              <td>2019-07-03 14:43:12</td>
            </tr>
          </table>
        </template>
      </div>
    </div>
    <div class="InfoWrap" v-show="applyStatus == 1">
      <h3>
        身份验证
        <a class="writebook frr" href="javaScript:" @click="bindMain"
          >绑定账户</a
        >
      </h3>
      <el-form
        ref="checkForm"
        :model="checkDate"
        :rules="checkrules"
        label-width="100px"
        label-position="left"
        style="margin-top:24px"
      >
        <el-form-item prop="name" label="真实姓名">
          <el-input
            v-model="checkDate.name"
            placeholder="真实姓名"
            class="login-form-input"
          ></el-input>
        </el-form-item>
        <el-form-item prop="idNo" label="身份证号">
          <el-input
            v-model="checkDate.idNo"
            placeholder="身份证号"
            class="login-form-input"
          ></el-input>
        </el-form-item>
        <p
          v-if="!isuse"
          style="font-size:12px;color:red;margin-left:100px;font-weight:600"
        >
          该身份证号已被其他签约作者使用，去绑定账户吧！
        </p>
        <el-form-item>
          <el-button
            style="margin-top:30px"
            class="usersub"
            size="medium"
            @click="checkNo('checkForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="InfoWrap bindwrap" v-show="applyStatus == 2">
      <h3>
        绑定账户
        <a class="writebook frr" href="javaScript:" @click="canclebind"
          >取消账户</a
        >
      </h3>
      <el-form
        ref="bindForm"
        :model="bindDate"
        :rules="bindrules"
        label-width="100px"
        label-position="left"
        style="margin-top:24px"
        v-if="!isbind"
      >
        <el-form-item prop="masterId" label="绑定账户ID">
          <el-input
            v-model="bindDate.masterId"
            placeholder="绑定账户ID"
            class="login-form-input"
          ></el-input>
        </el-form-item>
        <el-form-item prop="brealName" label="真实姓名">
          <el-input
            v-model="bindDate.brealName"
            placeholder="真实姓名"
            class="login-form-input"
          ></el-input>
        </el-form-item>
        <el-form-item prop="idNo" label="身份证号">
          <el-input
            v-model="bindDate.idNo"
            placeholder="身份证号"
            class="login-form-input"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            style="margin-top:30px"
            class="usersub"
            size="medium"
            @click="bindNo('bindForm')"
            >申请绑定</el-button
          >
        </el-form-item>
      </el-form>
      <ul v-if="isbind">
        <li>
          <span class="label">绑定账户</span>
          <span class="bindStatus" style="color:red">{{
            bindInfo.masterUserId
          }}</span>
        </li>
        <li>
          <span class="label">绑定状态</span>
          <span class="bindStatus" style="color:#09B21A">{{
            bindInfo.status == 1
              ? "正在审核"
              : bindInfo.status == 2
              ? "已通过"
              : bindInfo.status == -2
              ? "驳回"
              : "用户取消"
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  getSignInfo,
  checkidNo,
  signBook,
  sendCode,
  bindMainId,
  canclebind
} from "@/api/author";
import { isidNo, isAccount, encryptStr, decrypt } from "utils/core/kernel";
import { mapState } from "vuex";
import { AUTHOR } from "apiurl/index.js";
import { getToken } from "utils/storage";
export default {
  metaInfo: {
    title: "作者资料-源石阅读"
  },
  data() {
    //   验证身份证
    var validateidNo = (rule, value, callback) => {
      if (isidNo(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的身份证号"));
      }
    };
    /* 验证银行卡 */
    var isaccount = (rule, value, callback) => {
      if (isAccount(value)) {
        callback();
      } else {
        callback(new Error("请输入正确银行账号"));
      }
    };
    // 验证邮箱
    /*  var validatemail = (rule, value, callback) => {
      if (isEmail(value)) {
        callback();
      } else {
        callback(new Error("请输入正确银行账号"));
      }
    }; */
    return {
      signDate: {
        account: null, //银行卡号
        address: "", //地址
        bank: "", //开户行
        bookId: "", //作品id
        code: "", //邮箱验证码
        email: "", //邮箱
        im: "", //qq
        idBackImg: "",
        idFrontImg: "",
        realName: "",
        idNo: "",
        zipcode: "" //邮编
      },
      isbind: false, // 是否绑定主账号
      headers: {
        Authorization: "Bearer " + getToken()
      },
      uploadurl: "",
      uploaddata1: {
        type: 1
      },
      uploaddata2: {
        type: 2
      },
      checkDate: {
        name: "",
        idNo: ""
      },
      checkrules: {
        name: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
        idNo: [
          { required: true, message: "请输入你的身份证号", trigger: "change" },
          { validator: validateidNo, trigger: "change" }
        ]
      },
      bindDate: {
        brealName: "",
        idNo: "",
        masterId: ""
      },
      bindrules: {
        masterId: [
          { required: true, message: "请输入账户ID", trigger: "blur" }
        ],
        brealName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" }
        ],
        idNo: [
          { required: true, message: "请输入你的身份证号", trigger: "blur" },
          { validator: validateidNo, trigger: "blur" }
        ]
      },
      rules: {
        email: [{ required: true, message: "请输入你的邮箱", trigger: "blur" }],
        zipcode: [{ required: true, message: "请输入邮编", trigger: "blur" }],
        code: [
          { required: true, message: "请输入邮箱验证码", trigger: "blur" }
        ],
        bank: [
          { required: true, message: "请输入银行账户全称", trigger: "blur" }
        ],
        account: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
          { validator: isaccount, trigger: "blur" }
        ]
      },
      checked: true,
      triggerval: {
        chooseVal: ["作者信息", "签约信息"],
        chooseIndex: 0 // 切换信息：基本 签约
      },
      isSign: false, //是否签约
      applyStatus: 1, //状态判断
      isuse: true, // 身份证是否可用
      timestamp: null, // 保存时间戳
      isclick: true, //是否可发送验证码
      timecount: 60, //倒计时秒数
      timer: null, //计时对象
      signStatus: 0,
      bindInfo: {} //绑定成功候返回的信息
    };
  },
  created() {
    this.bookid = this.$route.params.id;
    // 获取签约信息
    this.SignInfo();
    this.$nextTick(() => {
      this.signDate.name = this.info.name;
      // 上传图片地址
      this.uploadurl = `${AUTHOR}/sign/contract/upload`;
    });
  },
  computed: mapState({
    info: state => state.user.img
  }),
  methods: {
    handleAvatarSuccess(res) {
      if (res.success) {
        this.signDate.idFrontImg = res.data;
      }
    },
    handlereverseSuccess(res) {
      if (res.success) {
        this.signDate.idBackImg = res.data;
      }
    },
    // 获取基本的签约信息
    async SignInfo() {
      let info = await getSignInfo(this.bookid);
      if (info && info.success) {
        if (info.data.apply) {
          this.applyStatus = 3;
          let signinfo = JSON.parse(info.data.apply.content);
          this.signDate.idBackImg = signinfo.idBackImg;
          this.signDate.idFrontImg = signinfo.idFrontImg;
          this.signDate.realName = signinfo.name;
          this.signDate.idNo = decrypt(signinfo.idNo, 1);
          this.signDate.address = info.data.userAuthor.address;
          this.signDate.zipcode = info.data.userAuthor.zipcode;
          this.signDate.bank = signinfo.bank;
          this.signDate.email = decrypt(signinfo.email);
          this.signDate.im = info.data.userAuthor.qq;
          this.signDate.account = decrypt(signinfo.accounts, 2);
          this.signStatus = info.data.apply.status;
          if (info.data.apply.status !== -2) {
            this.isSign = true;
          } else {
            this.isSign = false;
          }
        } else if (info.data.userAuthorRel) {
          this.applyStatus = 2;
          this.bindInfo = {
            masterUserId: info.data.userAuthorRel.authorId,
            status: info.data.userAuthorRel.status
          };
          this.isbind = true;
        } else {
          this.applyStatus = 3;
          this.isSign = false;
          this.signDate.realName = info.data.authorIdCard.name;
          this.signDate.idNo = decrypt(info.data.authorIdCard.idNo, 1);
          this.signDate.im = info.data.userAuthor.qq;
          this.signDate.address = info.data.userAuthor.address;
        }
      } else {
        if (info.code == 30023) {
          this.applyStatus = 1;
        }
      }
    },
    // 验证身份证号
    checkNo(from) {
      this.$refs[from].validate(valid => {
        if (valid) {
          let data = {
            name: this.checkDate.name,
            idNo: encryptStr(this.checkDate.idNo.trim(), 1),
            bookId: this.bookid
          };
          checkidNo(data)
            .then(res => {
              if (res.success) {
                //this.applyStatus = 3;
                window.location.href = res.data.verifyUrl;
              } else {
                if (res.code == 30006) {
                  this.isuse = false;
                }
              }
            })
            .catch(() => {});
        }
      });
    },
    // 获取邮箱验证码
    async getCode() {
      if (this.signDate.email) {
        let coderes = await sendCode(
          this.qs.stringify({
            email: encryptStr(this.signDate.email)
          })
        );
        if (coderes.success) {
          this.$message({
            message: "已发送到您的邮箱！",
            type: "success"
          });
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.timecount = TIME_COUNT;
            this.isclick = false;
            this.timer = setInterval(() => {
              if (this.timecount > 1 && this.timecount <= TIME_COUNT) {
                this.timecount--;
              } else {
                this.isclick = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      } else {
        this.$message.error("请输入您的邮箱");
      }
    },
    // 签约
    submitapply(form) {
      this.$refs[form].validate(valid => {
        if (this.signDate.idBackImg && this.signDate.idFrontImg) {
          if (valid) {
            let data = this.qs.stringify({
              account: encryptStr(this.signDate.account.trim(), 2),
              bank: this.signDate.bank,
              code: this.signDate.code,
              email: encryptStr(this.signDate.email),
              zipcode: this.signDate.zipcode,
              idBackImg: this.signDate.idBackImg,
              idFrontImg: this.signDate.idFrontImg
            });
            signBook(data, this.bookid)
              .then(res => {
                if (res.success) {
                  this.isSign = true;
                  this.SignInfo();
                }
              })
              .catch(() => {});
          }
        } else {
          this.$message.error("请先上传身份证");
        }
      });
    },
    // 绑定主账号显示
    bindMain() {
      this.applyStatus = 2;
    },
    canclebind() {
      if (this.bindInfo.status == 1) {
        this.applyStatus = 1;
        canclebind()
          .then(res => {
            if (res.success) {
              this.isbind = false;
            }
          })
          .catch(() => {});
      } else {
        this.applyStatus = 1;
      }
    },
    // 申请绑定主
    bindNo(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          let data = this.qs.stringify({
            masterId: this.bindDate.masterId,
            idNo: encryptStr(this.bindDate.idNo, 1),
            realName: this.bindDate.brealName
          });
          bindMainId(data)
            .then(res => {
              if (res.success) {
                this.bindInfo = {
                  masterUserId: res.data.masterUserId,
                  status: res.data.rel.status
                };
                this.isbind = true;
              }
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>
<style>
.authorInfo .el-form {
  padding: 0 170px 0 24px;
}
.authorInfo .el-form-item__content {
  text-align: center;
  line-height: 0px;
}
.InfoWrap .usersub.el-button {
  width: 124px;
  height: 34px;
  color: #fff;
  background: #48a2df;
  border: none;
  line-height: 15px;
}
.InfoWrap .login-form-input .el-input__inner {
  border-radius: 4px;
  height: 34px;
  font-family: PingFangSC-Regular;
}
.authorInfo .usersub.el-button span {
  vertical-align: top;
}
.authorInfo .usersub.el-button:focus {
  width: 124px;
  height: 34px;
  background: #48a2df;
  border-radius: 4px;
  border-color: #48a2df;
  color: #fff;
  height: 34px;
}
.authorInfo .usersub.el-button:hover {
  width: 124px;
  height: 34px;
  background: #48a2df;
  border-radius: 4px;
  border-color: #48a2df;
  color: #fff;
  height: 34px;
}
.InfoWrap .el-form-item__label {
  color: #333;
  font-size: 16px;
  height: 34px;
  line-height: 34px;
  font-family: PingFangSC-Regular;
}
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #fff;
  margin-right: 0px;
}
.authorInfo .el-input-group {
  margin-bottom: 0px;
}
.InfoWrap .el-input-group__append {
  background: #48a2df;
  text-align: center;
  color: #fff;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;
}
.InfoWrap .el-input__inner {
  height: 34px;
  line-height: 34px;
}
.InfoWrap .getcodebox {
  position: relative;
}
/* .InfoWrap .getcodebox .el-input__inner {
  width: 600px;
  position: absolute;
  left:0px;
} */
.InfoWrap .getmycode {
  position: absolute;
  cursor: pointer;
  width: 80px;
  height: 34px;
  background: #48a2df;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  color: #fff;
  top: 0px;
  right: 0px;
  text-align: center;
  border-radius: 0px 4px 4px 0;
  line-height: 34px;
}
.InfoWrap .isnoneclick {
  width: 117px;
}
</style>

<style lang="stylus" scoped>
h3
    background #fff
.authorInfo
    min-height 716px
.InfoWrap
    .normalbox
        margin 24px 75px 24px 24px
.hint
    font-size 12px
    color rgba(248, 81, 81, 1)
    margin-bottom 24px
.hintblue
    font-size 12px
    color #25a5cf
    margin-bottom 24px
    line-height 20px
    padding 3px 15px
    background rgba(240, 248, 255, 1)
.imgbox
    margin 20px 0
    .uploader
        width 150px
        height 150px
        overflow hidden
        margin 0 40px 0 110px
        img
            width 150px
            height 150px
    .egfront
        img
            width 150px
            height 150px
        li
            font-size 12px
            line-height 24px
            color rgba(51, 51, 51, 1)
            margin-left 18px
.IDphoto
    padding 23px 25px
    border 1px solid rgba(211, 211, 211, 1)
    border-radius 4px
    img
        width 250px
        display inline-block
        height 120px
        &:first-child
            margin-right 20px
.signStutus
    text-align center
    font-size 14px
    color #5C5C5C
    margin-bottom 14px
    .active
        color #25A5CF
table
    width 575px
    background rgba(240, 248, 255, 1)
    border-radius 4px
    font-size 12px
    border 1px solid rgba(218, 230, 241, 1)
    margin-left 130px
    margin-bottom 30px
    text-align center
    th
        color rgba(51, 51, 51, 1)
        height 32px
        line-height 32px
    td
        height 32px
        line-height 32px
.bindwrap
    ul
        padding: 30px 170px 0 24px;
        li
            height: 34px;
            line-height: 34px;
            .label
                display inline-block
                color: #333;
                font-size: 16px;
                height: 34px;
                line-height: 34px;
                width: 100px;
                font-family: PingFangSC-Regular;
            .bindStatus
                height: 34px;
                line-height: 34px;
                display inline-block
                width 60%
                font-size:14px
.signInfo
    padding-bottom 30px
</style>
